<template>
  <el-container :style="parent" class="parent">
    <el-header>产品防伪查询</el-header>
    <el-main>
      <el-row>
        <el-col :span="14">
          <el-form
            ref="form"
            :model="form"
            label-width="140px"
            class="mainform"
            @submit.native.prevent
          >
            <el-form-item label="请输入查询的码:">
              <el-input
                type="text"
                v-model="form.qrcode"
                @keyup.native.enter="handleDialogSelectRoom"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="formlistget"
            v-permission="['customerinquire_select']"
          >搜索</el-button>
        </el-col>
      </el-row>

      <br />
      <el-col :span="13" :offset="1">
        <!-- 第一次扫到正品码 -->
        <el-form
          ref="formlist"
          :model="formlist"
          style="text-align: left;"
          v-show="dialogVisible"
          class="mainform"
          center
        >
          <el-card class="box-card">
            <el-form-item label="查询数码结果:" label-width="115px"> <div style="font-size: 18px;">正品</div></el-form-item>
            <el-form-item label="数码信息:" label-width="115px">
              <div>{{formlist.qrcode}}由{{formlist.factoryName}}生产的系列产品，请放心使用，</div>
            </el-form-item>
             <el-form-item label="扫码次数:"  label-width="115px">
              <div>{{formlist.count}}</div>
            </el-form-item>
            <el-form-item label="首次扫码时间:" label-width="115px">
              <div>{{formlist.create_time}}</div>
            </el-form-item>
          </el-card>
        </el-form>
        <!-- 第二次扫到正品码 -->
        <el-form
          ref="formlist"
          :model="formlist"
          style="text-align: left;"
          v-show="Visiblenext"
          class="mainform"
          center
        >
          <el-card class="box-card">
           
            <el-form-item label="您所查询的编号为:" label-width="140px">
              <div>{{formlist.qrcode}}此产品已被扫描{{formlist.count}}次，请关注首次扫码时间。如有疑问，请拨打咨询电40088-51870</div>
            </el-form-item>
            <el-form-item label="扫码次数:" label-width="85px">
              <div>{{formlist.count}}</div>
            </el-form-item>
            <el-form-item label="首次扫码时间:" label-width="115px">
              <div>{{formlist.create_time}}</div>
            </el-form-item>
          </el-card>
        </el-form>
        <!-- 扫到假货 -->
        <el-form
          ref="formlist"
          :model="formlist"
          label-width="140px"
          v-show="Visible"
          class="mainform"
        >
          <el-card class="box-card">
            <div>该产品不是百雀羚官方正品！</div>
          </el-card>
        </el-form>
      </el-col>
    </el-main>
    <!-- <el-footer><el-image :src="src"></el-image></el-footer> -->
  </el-container>
</template>
<script>
import { qrcodecount } from "@/api/physical";
export default {
  data() {
    return {
      //接口参数
      form: {
        qrcode: "",
        pcquery: true // 区分h5跟后台查询
      },
      formlist: {},
      // 全屏css
      parent: {
        height: "600px"
      },
      footer: {
        height: "200px"
      },
      // 基础数据
      src: require("@/assets/css/img/气韵公众号二维码.png"),
      dialogVisible: false,
      Visible: false,
      Visiblenext: false
    };
  },
  mounted() {
    this.getheight();
  },
  methods: {
    // 获取url参数
    // 获取浏览器高度
    getheight() {
      this.$data.parent.height =
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) + "px";
      console.log(this.parent.height);
    },
    // 跟据链接参数调接口
    formlistget() {
      if (this.form.qrcode == "") {
        this.$message({
          message: "请输入码",
          type: "warning"
        });
      } else {
        qrcodecount({ qrcode: this.form.qrcode, pcquery: true }).then(
          response => {
            this.formlist = response.data;
            console.log(response.data);
            if (this.formlist.count == 0) { // 扫码次数为0 首次扫码时间则为空
              this.formlist.create_time = ''
            }
            if (this.formlist.ifForgery === false) {
              this.Visible = true;
              this.dialogVisible = false;
            } else {
                this.dialogVisible = true;
              this.Visible = false;
            }
          }
        );
      }
    },
    // enter按下事件
    handleDialogSelectRoom() {
      this.formlistget();
    }
  }
};
</script>
<style>
.parent .el-header {
  font-size: 20px;
  height: 50px !important;
  line-height: 50px;
  background-color: #03a9f4;
  color: aliceblue;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.parent .el-footer {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: auto !important;
  margin-bottom: 0px;
  padding: 0 0px;
}
</style>